<template>
  <div>
    <el-card>
      <h3>业务操作日志</h3>
      <el-table :data="tableData" border stripe style="margin-top:15px;">
        <el-table-column prop="id" label="日志ID" width="80"/>
        <el-table-column prop="operateUserId" label="操作人ID" width="100"/>
        <el-table-column prop="operateType" label="操作类型" width="140"/>
        <el-table-column prop="desc" label="操作描述" show-overflow-tooltip/>
        <el-table-column prop="ip" label="IP地址" width="180"/>
        <el-table-column prop="createTime" label="操作时间" width="180"/>
       </el-table>
      <el-pagination
        style="margin-top:15px;text-align:right;"
        background
        layout="total, prev, pager, next, jumper"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="currentPage"
        @current-change="fetchLogList"
      />
    </el-card>
  </div>
</template>
<script>
import adminRequest from '@/utils/adminRequest'
export default {
  data() {
  return {
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0
    }
  },
  mounted() {
    this.fetchLogList()
  },
  methods: {
    async fetchLogList() {
      try {
       const res = await adminRequest.get('/logList', {
        params: { page: this.currentPage, pageSize: this.pageSize }
      })
      this.total = res.data?.total || 0
      this.tableData = (res.data?.list || []).map(item => ({
          id: item.id,
          operateUserId: item.admin_id,
          operateType: item.operate_type,
          desc: item.description,
          ip: item.ip,
          createTime: item.create_time
        }))
      } catch (err) {
        console.error('获取操作日志失败：', err)
        this.tableData = []
      }
    }
  }
}
</script>